module.exports = __webpack_public_path__ + "img/GoodBye.0fc70871.png";